var React = require('react');

function IcMenu (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 8V6h18v2H3zm0 5h18v-2H3v2zm0 5h18v-2H3v2z","fill":"currentColor"}));
}

IcMenu.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = IcMenu;

IcMenu.default = IcMenu;
